import { Component, Input } from '@angular/core';

@Component({
  selector: 'p-vertical-separator',
  templateUrl: './p-vertical-separator.component.html',
  styleUrls: ['./p-vertical-separator.component.scss'],
})
export class PVerticalSeparatorComponent {
  @Input() height!: string;
}
